import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTour } from '../tour/TourContext';
import logoReversed from '../assets/logos/Cornerstone-reversed.svg';

const links: { to: string; label: string; end?: boolean; dataTour?: string }[] = [
  { to: '/', label: 'Home', end: true },
  { to: '/yards', label: 'Yards' },
  { to: '/sites', label: 'Sites' },
  { to: '/records', label: 'History' },
  { to: '/orders', label: 'Orders' },
  { to: '/import', label: 'Import' },
];

export default function Layout() {
  const { signOut } = useAuth();
  const { requestTour } = useTour();
  const navigate = useNavigate();
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <nav className="topnav">
        <img src={logoReversed} alt="Cornerstone" className="topnav-logo" style={{ marginRight: 4 }} />
        <button
          className="btn btn-primary"
          data-tour="nav-tour-btn"
          style={{ padding: '5px 14px', fontSize: 13 }}
          onClick={() => {
            requestTour();
            navigate('/');
          }}
        >
          Take a tour
        </button>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 16 }}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-tour={l.dataTour}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
            Profile
          </NavLink>
          <button className="btn btn-sm" onClick={() => signOut()}>
            Sign out
          </button>
        </div>
      </nav>
      <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </div>
    </div>
  );
}
